<template>

  <transition name="fade">

    <div class="mediaGallery" v-if="this.$props.show" @keyup.ctrl.tab="handleTabChange">
      <transition name="fade">
        <div class="mediaGallery__progress" v-if="loadingPage">
          <v-progress-circular :size="70" :width="7" indeterminate color="primary" class="center-block"></v-progress-circular>
        </div>
      </transition>

			<v-chip class="nav__pages white--text">{{ parseInt($route.params.pageNumber)+1 }} / {{ $props.pages }}</v-chip>

			<v-btn fab dark small flat class="nav__close" @click.prevent="$emit('close')">
				<v-icon dark>close</v-icon>
			</v-btn>

			<v-btn fab dark small flat class="nav__prev" @click.prevent="prev" v-if="parseInt($route.params.pageNumber) > 0">
				<v-icon>keyboard_arrow_left</v-icon>
			</v-btn>

			<v-btn fab dark small flat class="nav__next" @click.prevent="next" v-if="parseInt($route.params.pageNumber)+1 < $props.pages">
				<v-icon>keyboard_arrow_right</v-icon>
			</v-btn>

			<v-flex class="mediaGallery__footer text-center">

				<!-- <v-btn dark @click.prevent="prev" class="nav__left" v-if="parseInt($route.params.pageNumber) > 0"
					v-bind:class="{
						'super-comics-viewer-icons' :true
					}">
					<v-icon>keyboard_arrow_left</v-icon>
				</v-btn> -->

				<v-btn v-if="isFullScreenEnable"
					@click.prevent="onFullScreen()"
					v-bind:class="{
						active: $props.fullscreen,
						'super-comics-viewer-icons' :true
					}">
						<v-icon>fullscreen</v-icon>
				</v-btn>

				<v-btn @click.prevent="openThumbs()" class="super-comics-viewer-icons">
					<img src="../assets/img/pages.svg">
				</v-btn>

				<!-- <v-btn @click.prevent="$emit('close')"
					nav__close
					v-bind:class="{
						primary: $props.close,
						'super-comics-viewer-icons' :true
					}">
						<v-icon>close</v-icon>
				</v-btn> -->

				<!-- <v-btn dark @click.prevent="next" class="nav__right" v-if="parseInt($route.params.pageNumber)+1 < $props.pages"
					v-bind:class="{
						'super-comics-viewer-icons' :true
					}">
					<v-icon>keyboard_arrow_right</v-icon>
				</v-btn> -->

			</v-flex>

      <section class="mediaGallery__wrap">
        <video id="video" ref="video" autoplay></video> <!--controls-->
      </section>
    </div>
  </transition>

</template>

<script>
import bus from '@/utils/bus'
import Hammer from 'hammerjs/hammer.min.js'

export default {
	name: 'videoGallery',
	props: {
		show: false,
		fullscreen: false,
		data: '',
		pages: ''
	},
	data () {
		return {
			listenerKeydown: false,
			index: 0,
			keyCode: '',
			loadingPage: true,

			direction: 'top',
			fab: false,
			right: true,
			bottom: true,
			left: false,
			transition: 'slide-y-reverse-transition'
		}
	},
	computed:{
		isFullScreenEnable(){
			return  ( document.fullscreenEnabled ||  document.webkitFullscreenEnabled ||  document.mozFullScreenEnabled || document.msFullscreenEnabled )
		},
	},
	watch: {
		show: function(newVal) {
			if(newVal){
				setTimeout(() => {
					this.loadingPage = false
					this.build(this.$props.data.videoUrl)
				},1000)
			}
		},
		data: function(newVal) {
			this.index = 0
			this.build(newVal.videoUrl)
		}
	},
	methods: {
		initGestures(){
			var elementContainer = document.querySelector('.EdicaoVideo');
			var hammerContainer = new Hammer(elementContainer);

			hammerContainer.on('swipeleft', (e) => this.next() );
			hammerContainer.on('swiperight', (e) => this.prev()) ;
		},
		openThumbs(){
			bus.$emit('show-thumbs', true);
		},
		onFullScreen () {
			this.$emit('fullscreen');
		},
		build(videoUrl){

			this.loadingPage = true

			var video = document.getElementById('video');

			if(video === null) return;

			//video.pause();
			//video.currentTime = 0;

			while (video.firstChild) {
				video.removeChild(video.firstChild);
			}
			var source = document.createElement('source');
			source.setAttribute('src', videoUrl);

			video.appendChild(source);
			video.load();

			video.onloadeddata = () => {
				/*try{
					video.play();
				}catch(exc){ }*/
				this.loadingPage = false
			};

		},
		close() {
			this.$emit('close')
		},
		handleGlobalKeyup(e) {
			if(this.$props.show){
				this.keyCode = e.keyCode
				if(e.keyCode === 39)
					this.next()
				if(e.keyCode === 37)
					this.prev()
			}
		},
		prev(){
			this.$emit('prevPage')
		},
		next(){
			this.$emit('nextPage')
		}
	},
	mounted: function(){

		//this.initGestures()

		let self = this
		if(!this.listenerKeyup){
			this.listenerKeyup = true
			window.addEventListener('keyup', function(e) {
				self.handleGlobalKeyup(e)
			})
		}
	}
}
</script>

<style lang="scss">


</style>
